export default {
  // metadata (categorias/produtos/campos) — carregado do catálogo (mock agora, endpoint depois)
  catalogo: [],
  // valores editáveis keyed por produto/slug (ou chave de grupo): { [chave]: { ativo, valor: {} } }
  valores: {},
  dadosRetorno: {
    sucesso: false,
    mensagem: '',
    listaDeErros: {}
  },
  flagsDeControle: {
    carregandoDados: {
      status: false,
      mensagem: ''
    },
    manipulandoDados: {
      status: false,
      mensagem: ''
    }
  }
}
